<template>
<div >
    <div >
        <h2 class="text-center">Welcome to Bookings Dashboard</h2>
        <p class="text-center"> By default showing all bookings that were submitted last 7 days</p>
        <hr>
    </div>
     
    <div >
        <div class="col-sm-3 col-sm-offset-1" >
                <div class="filters">
                    <h5><i class="fa fa-cog" /> Filters and Preferences</h5>
                    <hr>
                    <div class="radio">
                        <label class="small"><input type="radio" value=5 v-model="searchData.BookingState">Show Started</label>
                    </div>
                    <div class="radio">
                        <label class="small"><input type="radio" value=0 v-model="searchData.BookingState">Show all Bookings</label>
                    </div>
                    <div class="radio">
                        <label class="small"><input type="radio" value=1 v-model="searchData.BookingState">Show Completed</label>
                    </div>
                    <div class="radio">
                        <label class="small"><input type="radio" value=2 v-model="searchData.BookingState">Show Cancelled</label>
                    </div>
                    <div class="radio">
                        <label class="small"><input type="radio" value=3 v-model="searchData.BookingState">Show Pending</label>
                    </div>
                    <div class="radio">
                        <label class="small"><input type="radio" value=4 v-model="searchData.BookingState">Show Sitter not responding</label>
                    </div>
                       <div class="form-to-date">
                        <div class="form-group">
                            <div class='input-group date' id='bookingsDashbaordFrom'>
                            <input v-model="searchData.FromDate" class="form-control input-text" readonly="true" placeholder="From Date" />
                            <span class="input-group-addon">
                                <span class="fa fa-calendar"></span>
                            </span>
                            </div>
                        </div>
                        </div>
                        <div class="form-to-date">
                        <div class="form-group">
                            <div class='input-group date' id='bookingsDashbaordTo'>
                            <input v-model="searchData.ToDate" class="form-control input-text" readonly="true" placeholder="To Date" />
                            <span class="input-group-addon">
                                <span class="fa fa-calendar"></span>
                            </span>
                            </div>
                        </div>
                        </div>
                    <div class="form-location">
                        <div class="form-group">
                            <div class='form-group '>
                                <select required v-if="countriesListComp" name="serviceSelect" class="form-control " v-model="searchData.BookingFilterCountryId">
                                  <option value="null" disabled selected hidden>Filter specific country</option>
                                  <option value="0" >All Countries</option>
                                  <option v-for="country in countriesListComp" v-bind:value="country.CountryId">
                                    {{country.CountryName}}
                                  </option>
                                </select>
                         
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-success btn-block" @click="applyFilters()">Apply Filters</button>
                    
                    
                    
                </div>
        </div>
        <div class="col-sm-7">
          
            <div class="col-sm-12">
                <div class="input-group col-md-12">
                    <input type="text" @keyup.enter="applyFilters()" v-model="searchData.SearchText" class="form-control input-lg" placeholder="Search Bookings, by Booking Number, Sitter or Customer Name or Email" />
                    <span class="input-group-addon">
                       <span class="fa fa-search"></span>
                    </span>
                    
                </div>
                <br>
            </div>
            
             <div v-if="!loading">
                <div  class="col-sm-12" >
                <h4 style="margin-top:0px;margin-bottom:0px; padding:5px;display:inline-block"><strong>Sory by:</strong></h4>
                <a  @click="sortList(0)"  v-bind:class="{'strong-font':isCurrentSort(0) }" href="javascript:;"  style="margin-top:0px; padding-right:5px;display:inline-block">None</a>
                <a @click="sortList(1)"    v-bind:class="{'strong-font':isCurrentSort(1) }" href="javascript:;"  style="margin-top:0px;  padding-left:5px; padding-right:5px;display:inline-block">Recent Submitted Date</a>
                <a @click="sortList(2)"    v-bind:class="{'strong-font':isCurrentSort(2) }" href="javascript:;"  style="margin-top:0px;  padding-left:5px; padding-right:5px;display:inline-block">Oldest Submitted Date</a>
                <a @click="sortList(3)"  v-bind:class="{'strong-font':isCurrentSort(3) }" href="javascript:;" style="margin-top:0px;  padding-left:5px; padding-right:5px;display:inline-block">Start Date</a>
                <a @click="sortList(4)"  v-bind:class="{'strong-font':isCurrentSort(4) }" href="javascript:;" style="margin-top:0px;  padding-left:5px; padding-right:5px;display:inline-block">End Date</a>
                <a @click="sortList(5)"  v-bind:class="{'strong-font':isCurrentSort(5) }" href="javascript:;" style="margin-top:0px;  padding-left:5px; padding-right:5px;display:inline-block">Sitter Id</a>
               
                
                
                
                <hr style="margin-top:0px;">
                </div>
            <div class="col-sm-12"  v-if="bookingsListComp.length>0" v-for="(booking, index) in bookingsListComp">
                <div class="sitterListbox card">
                    <div class="profile-body ">
                        <div class="bottom-row">
                            <div class="content col-sm-4">
                             
                                <h5 :class="booking.StatusAdminClass">Booking ID <strong>{{booking.BookingNumber}}</strong></h5>
                                <p class="small"><strong> Sitter: {{booking.SitterName}} </strong></p> 
                                <p class="small"><strong> Customer: {{booking.CustomerName}}</strong></p>
                                <p class="small"> Submitted: {{dateFormatter(booking.SubmittedDate)}}</p>
                                <p class="small"> Starts: {{dateFormatter(booking.StartDate)}}</p>
                                <p class="small"> Ends: {{dateFormatter(booking.EndDate)}}</p>
                                
                                
                            </div>
                            <div class="content col-sm-8">
                                <h5> Booking Status</h5>
                                <p :class="booking.StatusAdminClass" > <strong>{{booking.StatusAdminMessage}}</strong></p>
                                
                                <p class="small"> Sitter Status: {{booking.SitterStatus}}</p>
                                <p class="small"> Customer Status: {{booking.CustomerStatus}}</p>
                                   <div class="col-sm-12 remove-margins">
                                <h5><strong>{{booking.Country}}</strong></h5>
                                </div>
                                
                            </div>
                        </div>
                        
                    <div class="bottom-row pull-right">
                        <button @click="viewBooking(booking)" style="margin:3px;" class="btn btn-info btn-sm ">View Booking</button>
                        <button @click="adminHideBooking(booking)" style="margin:3px;" class="btn btn-danger btn-sm ">Hide Booking</button>
                        
                    </div>
                    </div>
                </div>
                </br>
            </div>
            </div>
              <div v-if="loading">
                <div class="spinner">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
                </div>
             </div>
                <div class="col-sm-12" v-if="!loading && bookingsListComp.length==0">
                    <div class="sitterListbox card"><p><i class="fa fa-warning"/> Ooopsy, no results match your search.</p></div>
                </div>  
         
        </div>
        
    </div>
</div>
</template>
<script>
 


import auth from '../../auth/index'
import store from '../../data/store'
import commonApi from '../../services/commonApi'
import customerApi from '../../services/customerApi'


export default {
 data() {
    return {
      error: '',
      bookingsList: '',
      alert: '',
      loading: true,
      searchData: {
          SearchText: '',
          BookingFilterCountryId: 0,
          BookingState: 0,
          FromDate: '',
          ToDate: '',
          SortBy: 0
      },
      emailConfirmed: true,
      title: "Dupaws Bookings Control",
      pending: true
    }
  },
  updated: function(){
      var self = this
      $('[data-toggle="popover"]').popover();
  
        // $zopim(function (){
        //     $zopim.livechat.hideAll();
            
        // });
        
        if (this.userRoleComp!="Admin"){
            this.$router.push({path: '/404'})
            return;
        }

        self.$nextTick(function () {
        var self = this
        $('#bookingsDashbaordFrom').datepicker({
          autoclose: true,
          format: 'yyyy-mm-dd',
          todayHighlight: true,
          beforeShowDay: function (date) {

          },
        }).on('changeDate', function (selected) { //When changing date..
          self.searchData.FromDate = moment(selected.date).format('YYYY-MM-DD')
        });
        $('#bookingsDashbaordTo').datepicker({
          autoclose: true,
          format: 'yyyy-mm-dd',
          todayHighlight: true,
          beforeShowDay: function (date) {

          },
        }).on('changeDate', function (selected) { //When changing date..
          self.searchData.ToDate = moment(selected.date).format('YYYY-MM-DD')
        });

      }); // end of nextTick!


  },
  mounted: function () {

    if (sessionStorage.getItem('BookingSearchText')!=null)
         {
             this.searchData.SearchText = sessionStorage.getItem('BookingSearchText')
        }
    
    
        if (sessionStorage.getItem('BookingFilterCountryId')!=null)
         {
             this.searchData.BookingFilterCountryId = sessionStorage.getItem('BookingFilterCountryId')
            
         }
        if (sessionStorage.getItem('BookingFilterFromDate')!=null)
         {
             
             this.searchData.FromDate = sessionStorage.getItem('BookingFilterFromDate')
            
         }


        if (sessionStorage.getItem('BookingState')!=null)
         {
                this.searchData.BookingState = sessionStorage.getItem('BookingState')
         }


        if (sessionStorage.getItem('BookingSortId')!=null)
         {
                this.searchData.SortBy = sessionStorage.getItem('BookingSortId')
         }
        if (sessionStorage.getItem('BookingFromDate')!=null)
         {
             this.searchData.FromDate  = moment(JSON.parse(sessionStorage.getItem('BookingFromDate')))
         }
        if (sessionStorage.getItem('BookingToDate')!=null)
         {
             this.searchData.ToDate  = moment(JSON.parse(sessionStorage.getItem('BookingToDate')))
         }


    
    this.$forceUpdate();
    this.getFilteredBookings()


    // $zopim(function (){
    //     $zopim.livechat.hideAll();
        
    // });


    // commonApi.getbookingsList(store.getters.QueryData)  //get sitters data
   

    
  },
  methods: {
    sortList: function(value){
          var self = this
           self.loading = true
           self.searchData.SortBy = value
           this.getFilteredBookings()
      },
    isCurrentSort(value){
        if (this.searchData.SortBy==value)
            return true
        else
            return false
      },
    adminHideBooking(booking){
        var self = this

          swal({
            title: "Confirmation",
            text: "Are you sure you want to Hide this booking?",
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: 'btn-danger',
            confirmButtonText: "Yes hide!",
            closeOnConfirm: true,
            html: true
        }, function(){
            $.ajax("https://www.dupaws.com/services/api/admin/hideBooking/" + booking.ServiceTransactionId,  {
                    type: 'GET',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        swal("success","Booking will no longer show up in search","success")
                    },
                    error: function () {
                    }
                }); 
        });

       
    },
    applyFilters: function(){
          this.loading = true
        this.getFilteredBookings()
      },
       dateFormatter: function(date){
            return moment(date).format('DD MMM YYYY')
    },
    viewBooking: function(booking){
        this.$router.push({path:'/view-admin-reservation/' + booking.ReservationId})
    },
    getFilteredBookings(){
        var self = this
        $.ajax("https://www.dupaws.com/services/api/admin/getFilteredBookings/",  {
                type: 'POST',
                beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                },
                data: JSON.stringify(self.searchData),
                dataType:"json",
                contentType: "application/json; charset=utf-8",
                crossDomain: true,
                success: function (data) {
                    self.bookingsList = data
                    self.loading = false
                },
                error: function () {
                }
            }); 
    },
   
  },   
  watch:{
      'searchData.SearchText': function(){
            sessionStorage.setItem('BookingSearchText', this.searchData.SearchText)
        // this.getFilteredBookings()
      },
      'searchData.BookingFilterCountryId': function(){
            sessionStorage.setItem('BookingFilterCountryId', this.searchData.BookingFilterCountryId)
          this.applyFilters()
      },
      'searchData.SortBy': function(){
            sessionStorage.setItem('BookingSortId', this.searchData.SortBy)
          this.applyFilters()
      },
      'searchData.BookingState': function(){
            sessionStorage.setItem('BookingState', this.searchData.BookingState)
          this.applyFilters()
      },
      'searchData.FromDate': function(){
          var self = this
            sessionStorage.setItem('BookingFromDate', JSON.stringify(moment(self.searchData.FromDate)))
          this.applyFilters()
      },
      'searchData.ToDate': function(){
          var self = this
            sessionStorage.setItem('BookingToDate', JSON.stringify(moment(self.searchData.ToDate)))
          this.applyFilters()
      }
      
   },
   head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function () {
      return {
        inner: this.title
      }
    }
  },
  computed: {
    countriesListComp: function(){
      return store.getters.CountriesList
    },
    errorMsg: function () {
      return this.error
    },
    alertMsg: function () {
      return this.alert
    },
    bookingsListComp: function(){
        if (this.bookingsList!=null)
            return this.bookingsList
    },
    userRoleComp: function(){
       return store.getters.userRole
     }
    
  },
  
}

 
</script>
<style scoped>



.filters{
    padding: 10px;
    border: 1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
}

.confirmed{
    font-weight: 700;
    color: green;
}

.reviews {
    margin-bottom: 0px;
    vertical-align: bottom;
    font-size: medium;
    margin-left: 0px;

}


.align-right {
  margin-left: auto;
}

.sitterListbox {
  display:flex;
  padding: 10px;
  flex-wrap: wrap;
  
}

.bottom-row {
  display: flex;
  justify-content: space-between
}

.sitterListbox .profile-img {
  height:75px;
  width:75px;
}

.sitterListbox .profile-body {
  flex: 3;
  padding-left: 10px;
  flex-wrap:wrap;
  
  
  
}

.sitterListbox .profile-body .profile-body-details{
  display:flex;
  flex-wrap: nowrap;
}

.sitterListbox .profile-body .profile-body-aboutme {
  display: flex;
  
}

.homewrapper{
    
    display: flex;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);
    background-color: aliceblue;
    transition: 0.3s;
    border-radius: 8px;
    border-bottom-width: inherit;
}

.home-icons {
  padding:3px;
}

.sitterListbox .profile-body h2 {
  margin-top:0px;
  margin-bottom:0px;
}

.sitterListbox .profile-price {
  flex: 1;
  
}

.inline {
  display: inline;
  vertical-align: middle;
  padding-right: 1px;
  
}


.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #ffffff;
    opacity: 1;
}


.fa-heart-o {
  color:#848484; opacity: 0.7;
}


.favorite {
    color:#af1818; opacity: 0.7;
    padding-left:10px;
    
}

.favorite:hover {
    opacity: 1;
}

.favorite:active {
    
    transform: scale(1.1);
}

.card {
    /* Add shadows to create the "card" effect */
    
    transition: 0.3s;
    border:1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    
    
}



/* On mouse-over, add a deeper shadow */
.card:hover {
    box-shadow: 0 10px 16px 0 rgba(1,0,0,0.2);
    background:  aliceblue;
    opacity: 1;
    
}
    
/* Add some padding inside the card container */

.strong-font{
    font-weight:600!important;
}
</style>


// WEBPACK FOOTER //
// BookingsDashboard.vue?a00b9126